<template>
    <div>
        <h3>Document Notifications</h3>
        <div class="row">
            <div class="wrapper col-md-12">
                <loader v-if="isLoading"></loader>
                <v-client-table :data="gridSpec.tableData" :columns="gridSpec.columns" :options="gridSpec.options">
                    <template slot="view" slot-scope="props">
                        <div style="text-align: center">
                            <a class="fa fa-edit" style="font-size: 18px;" v-on:click="viewRecord(props.row)"></a>
                        </div>
                    </template>
                    <template slot="download" slot-scope="props">
                        <div style="text-align: center">
                            <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" v-on:click="downloadMedia(props.row)"></a>
                        </div>
                    </template>
                    <template slot="archive" slot-scope="props">
                        <div style="text-align: center">
                            <a class="fa fa-ban" style="font-size: 18px;" target="_blank" v-on:click="archiveMedia(props.row)"></a>
                        </div>
                    </template>
                </v-client-table>
            </div>
        </div>
    </div>
</template>

<script>
import loggingService from '@/services/util/loggingService'
import mediaService from '@/services/mediaService'
import loader from '../components/Loader.vue'

export default {
    name: 'media-notification',
    components: {
        loader: loader
    },
    data: function () {
        return {
            labList: [],
            isDebug: false,
            isLoading: true,
            gridSpec: {
                columns: ['view', 'download', 'mediaTypeDescription', 'filename', 'createdBy', 'createdDate', 'archive'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        mediaTypeDescription: 'Type',
                        filename: 'File Name',
                        createdBy: 'Uploaded By',
                        createDate: 'create Date'
                    },
                    dateColumns: ['createdDate'],
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            }
        }
    },
    props: {
    },
    computed: {
    },
    mounted () {
        this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Media Notification', message)
        },
        loadData () {
            this.isLoading = true
            mediaService.listMediaNotification(this.$http).then(result => {
                this.gridSpec.tableData = result.data
                this.isLoading = false
            })
        },
        viewRecord (dto) {
            switch (dto.mediaTypeId) {
            case mediaService.mediaType.MoaAnnualReport:
                this.$router.push('/Moa/' + dto.parentId)
                break
            case mediaService.mediaType.PaAnnualReport:
                this.$router.push('/Pa/' + dto.parentId)
                break
            default:
                break
            }
        },
        downloadMedia (dto) {
            mediaService.get(this.$http, dto.mediaId, dto.mediaTypeId, null, dto.parentId).then(response => {
                mediaService.saveFileToDownload(response, dto.filename)
            })
        },
        archiveMedia (dto) {
            if (confirm('Are you sure you want to archive this notification?')) {
                mediaService.archiveMediaNotification(this.$http, dto.mediaNotificationId).then(response => {
                    this.loadData()
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// MediaNotification.vue?0d4e6e26